import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mCompany from 'models/company';
// Custom
import { companyDataShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const CompanySelectFieldFilter = ({ companyId, companies, onChange }) => {
  const sortedCompanies = mCompany.sortElements(companies);

  return (
    <ResourceSelectFieldFilter
      labelId="field.company"
      resourceId={companyId}
      resources={sortedCompanies}
      displayKey="name"
      onChange={onChange}
    />
  );
};

CompanySelectFieldFilter.propTypes = {
  companyId: PropTypes.number,
  companies: PropTypes.arrayOf(companyDataShape),
  onChange: PropTypes.func.isRequired,
};

CompanySelectFieldFilter.defaultProps = {
  companyId: null,
  companies: null,
};

const mapStateToProps = (state) => ({
  companies: state.company.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(CompanySelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/companies/assets/main/CompanySelectFieldFilter.js